import clsx from 'clsx';
import React from 'react';
import { ReactComponent as Active } from './activeIcon.svg';
import { ReactComponent as BackArrow } from './backArrowIcon.svg';
import { ReactComponent as Calendar } from './calendarIcon.svg';
import { ReactComponent as CloseIcon } from './close.svg';
import { ReactComponent as DeleteButton } from './deleteButtonIcon.svg';
import { ReactComponent as EditButton } from './editButtonIcon.svg';
import { ReactComponent as FilterWhite } from './filterWhite.svg';
import { ReactComponent as ForwardArrow } from './forwardArrow.svg';
import { ReactComponent as GlobeBase } from './globe.svg';
import { ReactComponent as Inactive } from './inactiveIcon.svg';
import { ReactComponent as InfoIconDark } from './infoIconDark.svg';
import { ReactComponent as MenuArrow } from './menuArrow.svg';
import { ReactComponent as MenuBar } from './menuBar.svg';
import { ReactComponent as Search } from './searchIcon.svg';

// Brand icons use fill="currentColor"; this wrapper injects the central
// `.brand-icon` colour (driven by @primary-color) on every render, so the
// icon colour is controlled in one place instead of per SVG / per usage.
const withBrandColor = (Icon) => {
  const BrandIcon = (props) => (
    <Icon {...props} className={clsx('brand-icon', props?.className)} />
  );
  return BrandIcon;
};

const Globe = withBrandColor(GlobeBase);

export {
  Active,
  BackArrow,
  Calendar,
  CloseIcon,
  DeleteButton,
  EditButton,
  FilterWhite,
  ForwardArrow,
  Globe,
  Inactive,
  InfoIconDark,
  MenuArrow,
  MenuBar,
  Search,
};
